import { render, staticRenderFns } from "./related-titles.vue?vue&type=template&id=13eba133&scoped=true"
import script from "./related-titles.vue?vue&type=script&lang=js"
export * from "./related-titles.vue?vue&type=script&lang=js"
import style0 from "./related-titles.vue?vue&type=style&index=0&id=13eba133&prod&theme=dark-theater&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13eba133",
  null
  
)

export default component.exports